const LAYOUT_ASSET_COMPONENT_PROPS = {
  ariaHidden: 'false',
  altText: 'illustration',
  width: '125px',
  height: '125px',
  testId: 'layout-asset',
};

export { LAYOUT_ASSET_COMPONENT_PROPS };
